import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { isSafeUpload } from '../../shared/utils/file-signature';

/**
 * Blocks unsafe files from every multipart upload before it leaves the
 * browser: the extension must be one we accept (JPG, JPEG, PNG, PDF, plus the
 * spreadsheet imports) and the file's content must actually be that type.
 * Placed inside ErrorInterceptor so the rejection shows its snackbar.
 */
@Injectable()
export class UploadSafetyInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const body = req.body;
    if (!(body instanceof FormData)) return next.handle(req);

    const files: File[] = [];
    body.forEach((value) => {
      if (value instanceof File) files.push(value);
    });
    if (files.length === 0) return next.handle(req);

    return from(Promise.all(files.map(isSafeUpload))).pipe(
      switchMap((results) => {
        const bad = files.find((_, i) => !results[i]);
        if (!bad) return next.handle(req);
        return throwError(
          () =>
            new HttpErrorResponse({
              status: 400,
              url: req.url,
              // A plain string, the shape every screen's error handler shows as-is.
              error: {
                error: `"${bad.name}" is not a valid file. It contains unsafe content.`,
              },
            }),
        );
      }),
    );
  }
}
